import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Consultants from "./pages/Consultants";
import Infrastructure from "./pages/Infrastructure";
import Training from "./pages/Training";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import ScrollToTop from "./components/ScrollToTop";
import EventPopup from "./components/EventPopup";
import AdminPanel from "./pages/AdminPanel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTop />
      <EventPopup />
        <Header />
        <div className="pt-32">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/consultants" element={<Consultants />} />
            <Route path="/infrastructure" element={<Infrastructure />} />
            <Route path="/training" element={<Training />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </div>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
